import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gramatura'
})
export class GramaturaPipe implements PipeTransform {

  transform(value: number, args?: any): string {
    if (args == 1) {
      switch (value) {
        case 1: return "kruszywo 0,8 - 1,2 mm";
        case 2: return "kruszywo 1,0 - 1,6 mm";
      }
    } else {
      switch (value) {
        case 1: return "ziarno 1 mm";
        case 2: return "ziarno 1,5 mm";
        case 3: return "ziarno 2 mm";
      }
    }
  }
}
